import { render, staticRenderFns } from "./UsersPrivilegeStatistics.vue?vue&type=template&id=2c4fdbfa&scoped=true&"
import script from "./UsersPrivilegeStatistics.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4fdbfa",
  null
  
)

export default component.exports